import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const ScheduleService = {
  getList: async () => {
    const response = await apiService.get("/schedule-breaks");
    console.log(response);
    return response.data;
  },
  getWorkingList: async () => {
    const response = await apiService.get("/working-schedules");
    console.log(response);
    return response.data;
  },
  create: async (updatedData) => {
    const response = await apiService.post(`/schedule-breaks`, updatedData);
    return response.data;
  },

  updateWorkingList: async (id, updatedData) => {
    const response = await apiService.put(
      `/working-schedules/${id}`,
      updatedData
    );
    return response.data;
  },

  update: async (id, updatedData) => {
    const response = await apiService.put(
      `/schedule-breaks/${id}`,
      updatedData
    );
    return response.data;
  },

  getbyId: async (id) => {
    const response = await apiService.get(`/schedule-breaks/${id}`);
    console.log("called", response);
    console.log("called", response.data);
    return response.data;
  },
   delete: async (id) => {
    const response = await apiService.delete(`/schedule-breaks/${id}`);
    return response.data;
  },
};
export default ScheduleService;
